import React, { useState } from "react";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import Loader from "../../Layouts/Loader/Loader";
import Input from "../../components/FormComponents/Input";
import Button from "../../components/FormComponents/Button";

const ImportAppModal = ({ id, onClose }) => {
  const [selectedFile, setSelctedFile] = useState();
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setSelctedFile(e.target.files[0]);
  };

  const handleImportApp = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("dump", selectedFile);

    try {
      setLoading(true);
      const response = await axiosInstance.post(`/app/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Zino-App-Id": id
        },
        timeout: 600000
      });
      toastSuccess(response.message);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
      onClose();
    }
  };
  return (
    <div className="builder_form">
      <Input type="file" onChange={handleFileChange} />
      {loading ? <Loader width="20px" /> : <Button onClick={handleImportApp}>Import App</Button>}
    </div>
  );
};

export default ImportAppModal;
